import { AddAccommodationReservation } from "Bands/pages/event-accommodation-block/containers/AddAccommodationPeople";
import { dataMetaSelector } from "Bands/state";
import { dispatchGetEventAccommodationReservations } from "Bands/state/data/actions/eventBlocks/eventAccommodationReservation";
import { dispatchGetEventAccommodationRoomsForBlock } from "Bands/state/data/actions/eventBlocks/eventAccommodationRoom";
import {
  BAND_ACTIONS,
  IAccommodationBlock,
  IAccommodationReservation,
} from "Bands/types";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { copy } from "shared/assets";
import { TableSkeleton, Title } from "shared/components";
import { Spacer } from "shared/layout";
import { IAPIState, ITheme } from "shared/types";
import { AccommodationReservationTable } from "../AccommodationReservationTable/AccommodationReservationTable";
import { DeleteAccommodationReservationModal } from "../DeleteAccommodationReservationModal/DeleteAccommodationReservationModal";
import { EditAccommodationReservationModal } from "../EditAccommodationReservationModal/EditAccommodationReservationModal";

interface EditAccommodationReservationProps {
  block: IAccommodationBlock;
}

const { accommodationBlock: blockCopy } = copy;

export const EditAccommodationReservation: React.FC<EditAccommodationReservationProps> =
  ({ block }) => {
    const [showEditModal, setShowEditModal] =
      useState<IAccommodationReservation | null>();
    const [showDeleteModal, setShowDeleteModal] =
      useState<IAccommodationReservation | null>();

    const dispatch = useDispatch();

    const { api: getRoomsMeta } = useSelector(
      dataMetaSelector(BAND_ACTIONS.getEventAccommodationRoomsForBlock)
    );

    const fetchAccommodationReservations = useCallback(
      (page: number = 1) => {
        dispatchGetEventAccommodationReservations({
          dispatch,
          blockId: block.id,
          page,
        });

        dispatchGetEventAccommodationRoomsForBlock(dispatch, block.id);
      },
      [block.id, dispatch]
    );

    useEffect(() => {
      fetchAccommodationReservations();
    }, [fetchAccommodationReservations]);

    return (
      <Spacer size="m">
        {showDeleteModal && (
          <DeleteAccommodationReservationModal
            accommodationReservation={showDeleteModal}
            blockId={block.id}
            handleClose={() => setShowDeleteModal(null)}
          />
        )}
        {showEditModal && (
          <EditAccommodationReservationModal
            accommodationReservation={showEditModal}
            blockId={block.id}
            handleClose={() => setShowEditModal(null)}
          />
        )}

        <Title
          title={blockCopy.create.peopleBlock.title}
          size="m"
          asComponent="h3"
        />
        <AddAccommodationReservation block={block} />

        {getRoomsMeta?.status === IAPIState.pending ? (
          <TableSkeleton nbRows={5} theme={ITheme.tertiary} />
        ) : (
          <AccommodationReservationTable
            block={block}
            fetchAccommodationReservations={fetchAccommodationReservations}
            setShowEditModal={setShowEditModal}
            setShowDeleteModal={setShowDeleteModal}
          ></AccommodationReservationTable>
        )}
      </Spacer>
    );
  };
